import { createAction } from 'redux-actions';

export const gameIdChanged = createAction('GAME_ID_CHANGED');
export const usernameChanged = createAction('JOIN_USERNAME_CHANGED');



// WEBPACK FOOTER //
// ./src/components/Join/actions.js